import { OrderItem } from "./project-summary";
import { OrderDetail } from "./project-summary";

export class OrderConfirmation {
    orders: ConfirmationOrder[];

    constructor() {
        this.orders = [];
    }
}

export class ConfirmationOrder {
    projectName: string;
    projectNumber: string;
    purchaseOrderNumber: string;
    paymentMethod: number;
    orderNumber: string;
    orderDetails: OrderDetail[];
    orderItems: OrderItem[];
    deliveryAddress: DeliveryAddress;
    trackingNumber: string;
    deliveryDates: string;
    carrierCode: string;
    carrierName: string;
    carrierWebsite: string;
    usedByAtcInLastYear: boolean;
    houseNo: string;
    street: string;
    city: string;
    region: string;
    country: string;
    postalCode: string;
    shipToName: string;
}

export class DeliveryAddress {
    addressLineOne: string;
    addressLineTwo: string;
    addressLineThree: string;
    addressLineFour: string;
    city: string;
    postalCode: string;
    state: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/order-confirmation.ts